import Vue from "vue";

function loopBlock(state, blocks) {
    for (let blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
        const block = blocks[blockIndex];
        if (block.type_id == "field_group") {
            loopBlock(state, block.blocks);
        } else if (block.type_id == "field") {
            state.blocks.push(block);
        }

    }
}
export default {
    setOrder(state, order) {
        state.order = order;
        Vue.set(state.order, 'mode', 'editMode')
        for (let stepIndex = 0; stepIndex < order.service.steps.length; stepIndex++) {
            const step = order.service.steps[stepIndex];
            loopBlock(state, step.blocks)
        }
        for (let dataIndex = 0; dataIndex < order.datas.length; dataIndex++) {
            const data = order.datas[dataIndex];
            let block = state.blocks.find(block => block.id == data.block_id);
            if (block) {
                block.data = data;
            }
        }
    },
    updateOrder(state, order) {
        state.order.amount = order.amount;
        state.order.price = order.price;
    },
    cleanOrder(state) {
        state.order = null;
        state.blocks = [];
        state.currentStep = 0;
    },
    setStepValidation(state, isValid) {
        state.currentStepIsValid = isValid;
    },
    setHasUpdate(state, hasUpdate) {
        state.hasUpdate = hasUpdate
    },
    updateField(state, params) {
        let block = state.blocks.find(block => block.id == params.blockId);
        if (block) {
            if (!block.data) {
                block.data = {};
            }
            if (block.data.value !== params.value) {
                block.data.value = params.value;
                state.hasUpdate = true;
            }
        }
    },
    updateFieldValidationStatus(state, params) {
        let block = state.blocks.find(block => block.id == params.blockId);
        if (block) {
            if (!block.isValid) {
                block.isValid = true;
            }
            block.isValid = params.value;
        }
    },
    nextStep(state) {
        if (state.currentStepIsValid) {
            if (state.currentStep + 1 < state.order.service.steps.length) {
                state.currentStep++;
            } else {
                state.order.mode = 'confirmation';
            }
        }
    },
    prevStep(state) {
        if (state.currentStep - 1 >= 0) {
            state.currentStep--;
        }
        if (state.order.mode == "confirmation") {
            state.currentStep = 0;
            state.order.mode = 'editMode';
        }
    },
    resetFieldError(state, params) {
        let block = state.blocks.find(block => block.id == params.blockId);
        if (block) {
            Vue.set(block, "errorMessages",[]);
        }
    },
    addFieldError(state, params) {
        let block = state.blocks.find(block => block.id == params.blockId);
        if (block) {
            if (typeof block.errorMessages !== Array) {
                Vue.set(block, "errorMessages",[]);
            }
            block.errorMessages.push(params.errorMessage);
            block.isValid = false;
        }
    },
    setOrderMode(state, editMode) {
        state.order.mode = editMode;
    }
}
